/**
 * 
 * @param {string | number} id 
 * @returns string
 */
export const userStatus = (id) => {
  const statuses = {
    "1": "Sponsor",
    "2": "Ekip Üyesi",
    "3": "Ekip Lideri",
    "4": "Değer Akım Yöneticisi",
    "5": "Proje Çalışanı"
  };
  return statuses[id] || "";
};
